import React from 'react';
import { XIcon } from 'lucide-react';
import { Toggle } from '../common/Toggle';
export const UserModal = ({
  isOpen,
  onClose
}) => {
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center" data-id="element-1154">
      <div className="bg-white rounded-lg w-full max-w-2xl mx-4" data-id="element-1155">
        <div className="flex justify-between items-center p-6 border-b" data-id="element-1156">
          <h2 className="text-xl font-semibold" data-id="element-1157">Crear Nuevo Usuario</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600" data-id="element-1158">
            <XIcon className="h-6 w-6" data-id="element-1159" />
          </button>
        </div>
        <div className="p-6" data-id="element-1160">
          <div className="space-y-6" data-id="element-1161">
            <div data-id="element-1162">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1163">
                Nombres y Apellidos
              </label>
              <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-1164" />
            </div>
            <div className="grid grid-cols-2 gap-4" data-id="element-1165">
              <div data-id="element-1166">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1167">
                  Tipo de Identificación
                </label>
                <select className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-1168">
                  <option data-id="element-1169">DNI</option>
                  <option data-id="element-1170">Pasaporte</option>
                  <option data-id="element-1171">CE</option>
                </select>
              </div>
              <div data-id="element-1172">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1173">
                  Número de Identificación
                </label>
                <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-1174" />
              </div>
            </div>
            <div data-id="element-1175">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1176">
                Correo electrónico
              </label>
              <input type="email" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-1177" />
            </div>
            <div data-id="element-1178">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1179">
                Rol
              </label>
              <select className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-1180">
                <option data-id="element-1181">Usuario</option>
                <option data-id="element-1182">Administrador</option>
                <option data-id="element-1183">Supervisor</option>
              </select>
            </div>
            <div data-id="element-1184">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1185">
                Estado
              </label>
              <Toggle data-id="element-1186" />
            </div>
          </div>
        </div>
        <div className="border-t p-6 flex justify-end gap-4" data-id="element-1187">
          <button onClick={onClose} className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50" data-id="element-1188">
            Cancelar
          </button>
          <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700" data-id="element-1189">
            Guardar
          </button>
        </div>
      </div>
    </div>;
};